import { matchRoutes, useLocation } from 'react-router-dom';
import { currentLang } from '../../../utils/lang';
import { routePaths } from '../router/paths';
export const useCurrentPath = () => {
    const location = useLocation();
    const currentLanguage = currentLang();
    const routes = Object.entries(routePaths).map(path => {
        const [pathName, pathLocales] = path;
        return { path: pathLocales[currentLanguage] };
    });
    const matches = matchRoutes(routes, location);
    if (!matches) {
        return '';
    }
    return matches[0].route.path;
};
